import React from "react";

export default function(){
  return(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
    <rect width="256" height="256" fill="none" />
    <line x1="128" y1="40" x2="128" y2="216" fill="none" stroke="currentColor" strokeLinecap="round"
          strokeLinejoin="round" strokeWidth="16" />
    <polyline points="56 144 128 216 200 144" fill="none" stroke="currentColor" strokeLinecap="round"
              strokeLinejoin="round" strokeWidth="16" />
  </svg>
  );
}